<template>
    <div>
        <form-container v-if="!$store.state.local.loader"
                        header-text="Spieler Leihe" :width="400"
                        :action="action" :valid-actions="['leihe']"
                        header-icon="mdi-card-account-details" @save="save()"
                        :button-cancel="buttonCancel" :button-ok="buttonOk">
            <v-card-text v-if="rules " class="px-6"><!--&& vereine.length > 0-->
                <div v-if="spielerLeihe">
                    Der Spieler ist bereits an Verein <span class="font-weight-bold">{{spielerLeihe.lvVereinId}}</span>
                    verliehen. Ein Änderung kann nur vom Passreferenten durchgeführt werden.
                </div>
                <div v-else>
                    Bitte wähle den Verein an den der Spieler verliehen werden soll:
                    <v-row v-if="spieler" no-gutters class="mt-3">
                        <v-col cols="12" class="px-0 py-0 mb-1">
                            <div class="grey--text caption font-weight-light">Landesverband Stammverein</div>
                            <div style="border-bottom: solid 1px lightgrey;"
                                 class="grey--text text--darken-0 subtitle-1 mb-3">
                                {{lv.name}}</div>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0 mb-1">
                            <div class="grey--text caption font-weight-light">Stammverein</div>
                            <div style="border-bottom: solid 1px lightgrey;"
                                 class="grey--text text--darken-0 subtitle-1 mb-3">
                                {{currentVerein.id}} - {{currentVerein.name}}</div>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0">
                            <v-select :items="lvListe" v-model="newLv"
                                      item-text="name" label="Landesverband Leihverein"
                                      item-value="id" :rules="[rules.required]">
                            </v-select>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0">
                            <v-select :items="vereinsListe" v-model="newVerein"
                                      item-text="label" label="Leihender Verein"
                                      item-value="id" :rules="[rules.required]">
                            </v-select>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </form-container>
    </div>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import {FormRules} from "../../../services/formRules";
    import SPIELER_MEMBERSHIP_HANDLER from "../../../services/data/spieler/spielerMembershipHandler";
    import SPIELER_CHANGE_HANDLER from "../../../services/data/spieler/spielerChangeHandler";

    export default {
        components: {FormContainer},
        name: "spieler-leihe",
        props: ['spieler', 'action', 'actionObject', 'lv'],
        data: () => ({
            rules: null,
            newLv: null,
            newVerein: null,
        }),
        created(){
            this.rules = new FormRules();
            if ( this.$route.query.action ) { console.log ("CREATED FORMCONTAINER" ); window.history.back() }
        },
        computed: {
            buttonOk(){
                return this.spielerLeihe ? 'ok' : 'speichern';
            },
            buttonCancel(){
                return this.spielerLeihe ? '' : 'abbrechen';
            },
            spielerLeihe(){
                return this.spieler ? this.spieler.memberships.find(membership => membership.leihe) : null;
            },
            currentMembership() { return this.spieler ?
                SPIELER_MEMBERSHIP_HANDLER.getMembershipForTodayOrFuture(this.spieler.memberships) : null },
            currentVerein() {
                if ( !this.currentMembership || !this.lv ||
                    !this.$store.state.realtime.landesverbaende[this.lv.id] ) { return '' }
                let currentVereinNr = this.currentMembership.lvVereinId.substr(2);
                return {id: currentVereinNr,
                    name: this.$store.state.realtime.landesverbaende[this.lv.id] ?
                        this.$store.state.realtime.landesverbaende[this.lv.id].vereine[currentVereinNr].name : ''
                };
            },
            vereine(){
                //return this.$store.getters.getListFromKeys('realtime', 'landesverbaend', 'vereine', 'name');
                return this.newLv && this.$store.state.realtime.landesverbaende[this.newLv] ?
                    this.$store.getters.getListByStoreLink(
                        this.$store.state.realtime.landesverbaende[this.newLv].vereine, 'name') : [];
            },
            lvListe(){
                if ( this.$store.state.user.permissions['lv' + this.lv.id] ) {
                    return this.$store.state.local.landesverbaende
                        .filter( landesverband => landesverband.sportart === this.spieler.sportart);
                } else {
                    let list = [];
                    this.$store.state.local.landesverbaende.forEach( (lv) => {
                        if ( this.$store.state.user.permissions['lv' + lv.id] ) {
                            list.push(lv);
                        }
                    });
                    return list;
                }
            },
            vereinsListe(){
                let list = [];
                this.vereine.forEach( (item) => {
                    if ( this.currentVerein.id !== item.id ) {
                        item.label = item.id + ' - ' + item.name;
                        list.push(item)
                    }
                });
                return list.sort((a, b) => a.label > b.label ? 1 : -1);
            },
            user(){ return this.$store.state.user; },
        },
        methods: {
            async save(){
                if ( this.spielerLeihe ) { window.history.back(); return }
                this.$store.state.local.loader = true;
                let lvNew = this.lvListe.find( lv => lv.id === this.newLv );
                this.spieler.local.documentUpdates = SPIELER_CHANGE_HANDLER
                    .getDataObjectForLeihe( this.spieler, lvNew, this.newVerein);

                await this.spieler.updateWithTransaction('spieler_edit', false);
                window.history.back();
                this.$store.state.local.loader = false;
            },
            loadLandesverband(){
                if ( !this.$store.state.realtime.landesverbaende[this.newLv] &&
                    (this.user.permissions['lv' + this.newLv] || this.user.permissions.pass) ) {
                    this.$store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: this.newLv,
                        storeField: 'landesverbaende.' + this.newLv,
                    });
                }
            }
        },
        watch: {
            newLv(){
                this.loadLandesverband();
            }
        }
    }
</script>

<style scoped>

</style>